import { showToast } from '@bp/ui-components';

export function showSuccessToast(text: string) {
  showToast(text, {
    autoClose: 2000,
    type: 'success',
  });
}
